(function () {
  if (window.__gridCarouselInit) return;
  window.__gridCarouselInit = true;

  function setSlide(carousel, index) {
    var total = parseInt(carousel.getAttribute('data-total') || '1', 10);
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    carousel.setAttribute('data-current', index);

    var slides = carousel.querySelectorAll('.grid-product__carousel-slide');
    slides.forEach(function (s) {
      var slideIndex = parseInt(s.getAttribute('data-slide') || '0', 10);
      var active = slideIndex === index;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
      s.setAttribute('tabindex', active ? '0' : '-1');
    });

    var dots = carousel.querySelectorAll('.grid-product__dot');
    dots.forEach(function (d) {
      var dotIndex = parseInt(d.getAttribute('data-dot') || '0', 10);
      d.classList.toggle('is-active', dotIndex === index);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var carousel = btn.closest('[data-grid-carousel]');
    if (!carousel) return;
    e.preventDefault();
    e.stopPropagation();
    var current = parseInt(carousel.getAttribute('data-current') || '0', 10);
    var direction = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    setSlide(carousel, current + direction);
  });
})();
